import getApi from '../../api'
import { LegalDocument } from '../../model/LegalDocument'
import { sanitizeLegalDocumentResponse } from './legalDocument.mapper'

export const getLegalDocument = (type: string, signal?: AbortSignal) =>
  getApi()
    .get<LegalDocument>(`legal_documents/${type}`, {}, { signal })
    .then(sanitizeLegalDocumentResponse)
